export enum DirectionType {
    horizontal = "horizontal",
    vertical = "vertical"
}
